export interface AppButtonColors {
  enabled: string;
  pressed: string;
}

export interface AppButtonsColors {
  games: AppButtonColors;
  entityServices: AppButtonColors;
}

export interface AppColors {
  appButtons: AppButtonsColors;
}

export const appColors: AppColors = {
  appButtons: {
    games: {
      enabled: '#e7bc42',
      pressed: '#ca980a',
    },
    entityServices: {
      enabled: '#1A9E96',
      pressed: '#1B7171',
    },
  },
};

export const chartColors: Array<string> = [
  '#00a3ff',
  '#8f9aff',
  '#00baec',
  '#64c447',
  '#d78df5',
  '#ff80d5',
  '#00c1cd',
  '#ff7da9',
  '#e24a8e',
  '#ff8b7a',
  '#00c5a4',
  '#ffa64e',
  '#ffc32a',
  '#d55bb2',
  '#00c676',
  '#00b0fe',
  '#9a83ea',
  '#a2bd15',
  '#e34268',
  '#6a94f9',
  '#bd6fd2',
  '#da4542',
];

export const shiftsBackgroundColors = {
  dark_gray: {
    dark: '#504F4F',
    light: '#DADADA',
  },
  blue: {
    dark: '#2656CD',
    light: '#CBECFD',
  },
  green: {
    dark: '#1A5654',
    light: '#C7E4D6',
  },
  slate_blue: {
    dark: '#5243AA',
    light: '#EAD8F8',
  },
  purple: {
    dark: '#78206B',
    light: '#F8D5F6',
  },
  orange: {
    dark: '#B23E0C',
    light: '#FFC4B1',
  },
  russet: {
    dark: '#B05703',
    light: '#FFD7B5',
  },
  mustard: {
    dark: '#B18B00',
    light: '#FEE297',
  },
} as const;
